<template>
    <NuxtLayout>
        <ImmersionFrame />
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {NuxtPage, ImmersionFrame} from '#components';
</script>
